import { createContext } from 'react';
import type { SettableLineApprovalState } from '@erp/rpc';
import type { AssignmentLine } from 'src/api/rpc/hooks/procurement/useReplenishmentSuggestions';

export interface CartInclusionContextValue {
  /** Approved lines: what Release puts on the order. */
  selectedIds: Set<string>;
  onSetApproval: (
    line: AssignmentLine,
    state: SettableLineApprovalState,
  ) => void;
}

export const CartInclusionContext =
  createContext<CartInclusionContextValue | null>(null);
